import * as React from 'react';

import './Colorbar.scss';

class ColorBar extends React.Component<ColorBar.IProps, ColorBar.IState> {
  render() {
    return <div className="eon-bar" />;
  }
}

export default ColorBar;
